module.exports = __webpack_public_path__ + "img/boxing2.8f662a95.png";